/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step2body1Inputs */

const zh_landing_workflow_step2body1 = /** @type {(inputs: Landing_Workflow_Step2body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从简答到多步骤题目，都自带答案与评分标准。`)
};

const en_landing_workflow_step2body1 = /** @type {(inputs: Landing_Workflow_Step2body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From short-answer to multi-step problems with auto-graded keys.`)
};

const es_landing_workflow_step2body1 = /** @type {(inputs: Landing_Workflow_Step2body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde respuestas cortas hasta problemas de varios pasos con claves autoevaluadas.`)
};

/**
* | output |
* | --- |
* | "From short-answer to multi-step problems with auto-graded keys." |
*
* @param {Landing_Workflow_Step2body1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step2body1 = /** @type {((inputs?: Landing_Workflow_Step2body1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step2body1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step2body1(inputs)
	if (locale === "en") return en_landing_workflow_step2body1(inputs)
	return es_landing_workflow_step2body1(inputs)
});
export { landing_workflow_step2body1 as "landing_workflow_step2Body" }